export const getAutomaticLoginRootUrl = (rootUrl: string, token: string) => {
  try {
    const url = new URL(rootUrl);
    url.searchParams.set("automatic_login", "true");
    url.searchParams.set("token", token);
    return url.toString();
  } catch {
    return rootUrl;
  }
};

export const communitySwitcherInitials = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed) {
    return "?";
  }
  return trimmed.slice(0, 1).toUpperCase();
};
